import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { getResetStateMutation } from "@/store/helpers/helpers";

const getDefaultState = () => ({
  mediaAccessError: null,
  videoChats: [],
  videoChatMembers: [],
  oneToOneChatParticipantFullName: "",
  activeVideoChat: null,
  activeVideoSession: null,
  publisher: null,
  subscribers: [],
  streams: [],
  connectionsCount: 0,
  videoCallInitiator: null,
  videoMediaDevices: [],
  activeVideoDevice: null
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    resetState: getResetStateMutation(getDefaultState)
  },
  actions,
  getters
};
